import {createClient} from 'contentful'

export default createClient({
    space: "0k4gzc35hvbt",
    accessToken: "YCX6Dv_-82flb8ILkWCXel8rU1s0m1XiCnfeAyEjlN4"
})